const $ = window.jQuery;
let loadmore = $('.loadmore_posts');

if (loadmore.length) {
  sessionStorage.setItem('page', 2);
}
$(document).on('click', '.loadmore_posts', function (event) {
  event.preventDefault();
  let ajaxUrl = document.location.origin + '/cms/wp-admin/admin-ajax.php';
  let query_vars = $('.post_content').attr('data-query');
  let current_page = sessionStorage.getItem('page') || 1;

  $.ajax({
    url: ajaxUrl,
    type: 'post',
    data: {
      action: 'ajax_pagination',
      query_vars: query_vars,
      page: current_page,
    },
    beforeSend: function () {
      loadmore.text('Loading...');
    },
    success: function (html) {
      if (html == '<h3 class="text-center">You\'re All Caught Up.</h3>') {
        loadmore.hide();
      }
      $('.nav-links').remove();
      loadmore.text('Show more');
      current_page++;
      sessionStorage.setItem('page', current_page);
      $('.post_content').append(html);
    },
  });
});
